<template>
  <div id="app">
    <screen-full/>
    <transition :name="transitionName">
     <span>
        <keep-alive>
      <router-view class="Router" v-if="$route.meta.keepAlive">
      </router-view>
    </keep-alive>
    <router-view class="Router" v-if="!$route.meta.keepAlive"/>
     </span>
    </transition>
    <CustomToast :msg-list="msgList"></CustomToast>
    <MsgActionDialog show-msg-dialog="true" :msg="msgAction.msg"
                     :msg-dialog-show="msgAction.showMsgWithAction" :btns="msgAction.msgActions"
                     :type="msgAction.msgActionType"
                     :hide-from-out-side="msgAction.msgActionHideFromOutside"
                     @hideMsgWithActionDialog="hideMsgActionDialog"
                     @msgAction1="msgAction.doMsgAction1()"
                     @msgAction2="msgAction.doMsgAction2()"></MsgActionDialog>
    <rechargeSuc :coins="rechargeSucCoin" :show-recharge-suc="showAfRec" :type="rechargeType" :is-s-vip="svipAfRec"
                 @hideRechargeSuc="hideRechargeSucDialog" @toSignupAf="toSignup"></rechargeSuc>
    <DeviceError :device-error-show="showDeviceError" @hidedeviceerror="hideDeviceErrorDialog"></DeviceError>
    <RechargeDialog :recharge-dialog-show="showRecharge" @hideRecharge="()=>{
      this.showRecharge=false
    }"></RechargeDialog>
    <AlertDialog :msg="alertAction.msg" :title="alertAction.title"
                 :action-dialog-show="alertAction.showAlertAction" :btns="alertAction.alertActions"
                 :type="alertAction.alertActionType"
                 :hide-from-out-side="alertAction.alertActionHideFromOutside"
                 @hideCommonActionDialog="hideAlertActionDialog"
                 @commonaction1="alertAction.doAlertAction1()"
                 @commonaction2="alertAction.doAlertAction2()"></AlertDialog>
    <ReportBlockDialog :acc="report.acc" :show-report="report.show" :type="report.type" :room="report.room"
                       :suc-callback="report.callback" @hideReport="()=>{report.show=false}"></ReportBlockDialog>
    <RequestCall ref="rc"></RequestCall>
    <HtmlPage :type="htmlPage.type" :url="htmlPage.url" :showHtmlDialogWidget="htmlPage.show" :wh-rate="htmlPage.whRate"
              @hideHtmlDialogWidgetPage="hideHtmlDialogWidgetPage"></HtmlPage>
    <AutoPlayGuideDialog :show-play-guide="showAutoPlayGuide" @hideAutoPlayGuide="()=>{
      this.showAutoPlayGuide=false;
    }"></AutoPlayGuideDialog>
    <PreLoader :empty-loader-show="showPreLoader"></PreLoader>
    <LCMessageDialog :new-lc-msg-list="lcMsgList" ref="newMsgLayer" @removeLCMsg="removeLCMsg"></LCMessageDialog>
    <VcrGuide :guide-show="vcrGuide.showed" :boss-btm="vcrGuide.bossBtm" :anchor-btm="vcrGuide.anchorBtm"
              @hideVCRGuide="()=>{
        vcrGuide.showed=false
      }"></VcrGuide>
    <PhotoGallery :img-list="photos.imgList" :start-index="photos.startViewIndex" @hidePhotoGallery="()=>{
      photos.bigImgShow=false
    }" :photo-gallery-show="photos.bigImgShow" :from="photos.from"></PhotoGallery>
    <GreetDialog :greet-tips-show="greet.show" :account-id="greet.accountId" :do-after-callback="greet.callback"
                 :do-after-failed-callback="greet.failCallback"
                 @sayHi="toSayHI" @hideGreetTipsDialog="()=>{
                   this.greet.show=false
                 }"></GreetDialog>
    <MomentReportDialog :type="momReport.type" :id="momReport.id" :show-report="momReport.show"
                        :suc-callback="momReport.sucCallback"
                        @hideMomReport="hideMomentReport"></MomentReportDialog>
    <BigVideoPlayer :src="video.src" :poster="video.poster" :video-show="video.show"
                    @hideHLSPlayer="hideVideo"></BigVideoPlayer>
    <VK :show-validate="vk.needValidate" :suc-callback="vk.sucCallback" :failed-callback="vk.failedCallback"></VK>
    <GameDialog :game-dialog-show="game.show" :game-list="game.gameList" :type="game.from" @hideGame="()=>{
      game.show=false
    }"></GameDialog>
    <RoomToolDialog :show-tool="roomTool.show" :type="roomTool.type" :boss-camera-off="roomTool.cameraOff"
                    :boss-mic-off="roomTool.micOff" :recharge-callback="roomTool.rechargeCallback"
                    :clear-callback="roomTool.clearCallback"
                    :pur-off="roomTool.pureOff"
                    :camera-callback="roomTool.cameraCallback" :mic-callback="roomTool.micCallback"
                    :flip-callback="roomTool.flipCallback" :self-boss="roomTool.selfBoss"
                    @hideRoomTool="()=>{
                      roomTool.show=false
                    }"
    ></RoomToolDialog>
    <CallEndDialog :type="callEnd.type" :show-call-end="callEnd.show" :room-id="callEnd.roomId" :avatar="callEnd.avatar"
                   :name="callEnd.name" @hideCallEnd="hideCallEndDialog"></CallEndDialog>
  </div>
</template>

<script>
  import router from './router'
  import {
    isnull,
    localClear,
    localSave,
    Toast,
    ToastType,
    ToastTime,
    getUUID,
    localGetBoolean, localGet, showDialog, getVal, hideDialog, judgeLink, formatLink, validate, getZoneTime
  } from './utils/tools'
  import {reloginInBg, createSSE, doPay, doLoginAsVisitorWithTK, doLoginAsVisitor} from './api/home-api'
  import ScreenFull from './components/widget/screenfull'
  import CustomToast from './components/widget/Toast'
  import Tips from './utils/Tips'
  import global from "./config/global";
  import MsgActionDialog from './components/widget/msgdialog'
  import AlertDialog from './components/widget/commondialog'
  import RechargeDialog from './components/widget/rechargedialog'
  import rechargeSuc from './pages/mine/rechargesuccess'
  import DeviceError from './pages/svc/call/deviceerrordialog'
  import RequestCall from './pages/svc/call/requestcalldialog'
  import EventBusConstant from "./push/const/EventBusConstant";
  import IMManager from "./im/IMManager";
  import TipsUtils from "./utils/TipsUtils";
  import StatisticsHelper from "./utils/StatisticsUtils";
  import ReportBlockDialog from './components/widget/reportdialog'
  import accountApi from './api/account-api'
  import HWLPLayer from "./utils/hwlplayer";
  import ring from "../static/attach/sd_call.mp3";
  import BlackUtils from "./utils/BlackUtils";
  import HtmlPage from './components/widget/htmlpanel'
  import AutoPlayGuideDialog from './components/widget/autoplayguidedialog'
  import PreLoader from './components/widget/predataholder'
  import LCMessageDialog from './components/widget/lcmessagedialog'
  import VcrGuide from './components/widget/vcrguide'
  import PhotoGallery from './components/widget/PhotoGallery'
  import BigVideoPlayer from './components/widget/VideoPlayer'
  import GreetDialog from './components/widget/moment/greettipsdialog'
  import MomentReportDialog from './components/widget/moment/momentreportdialog'
  import MomentHelper from "./utils/mom/MomentHelper";
  import accAPi from "./api/account-api";
  import aes from "./utils/aes";

  import VK from './components/widget/validate4new'
  import GameDialog from './components/widget/gamedialog'
  import RoomToolDialog from './components/widget/roomtool'
  import CallEndDialog from './components/widget/callenddialog'
  import AppHelper from "./utils/AppHelper";

  const {tryInitAVIMClient} = require("./im/IMManager");

  export default {
    name: 'App',
    provide() {
      return {
        reload: this.reload
      }

    },
    data() {
      return {
        callEnd: {
          type: 1,
          show: false,
          roomId: 0,
          avatar: '',
          name: '',
        },
        roomTool: {
          type: 0,
          selfBoss: false,
          show: false,
          micOff: false,
          cameraOff: false,
          pureOff: false,
          rechargeCallback: null,
          clearCallback: null,
          micCallback: null,
          cameraCallback: null,
          flipCallback: null,
        },
        game: {
          show: false,
          gameList: [],
          from: 0,
        },
        inLogin: false,
        vk: {
          needValidate: false,
          sucCallback: null,
          failedCallback: null,

        },
        video: {
          src: '',
          poster: '',
          show: ''
        },
        momReport: {
          show: false,
          id: '',
          type: 0,
          sucCallback: null
        },
        greet: {
          accountId: '',
          show: false,
          callback: null,
          failCallback: null,
          momentHelper: null,
        },
        vcrGuide: {
          showed: false,
          bossBtm: 0,
          anchorBtm: 0
        },
        showPreLoader: true,
        showAutoPlayGuide: false,
        htmlPage: {
          show: false,
          url: '',
          type: 1,//1-dialog 2-close,
          whRate: 1//宽高比
        },
        report: {
          acc: '',
          show: false,
          room: '',
          type: 1,
          callback: {}
        },
        showRecharge: false,
        isRouterAlive: true,
        showDeviceError: false,
        onLine: navigator.onLine,
        showAfRec: false,
        svipAfRec: false,
        rechargeType: 1,
        rechargeSucCoin: 0,
        transitionName: '',
        loadingObj: '',
        msgList: [],
        lcMsgList: [],
        msgAction: {
          msg: 'Logged in on other device, please try again',
          showMsgWithAction: false,
          msgActionType: 0,
          msgActions: [],
          msgActionHideFromOutside: false,
          doMsgAction1() {
          },
          doMsgAction2() {
          },
          extra: {}

        },
        alertAction: {
          title: 'Alert',
          msg: Tips.hungupConf,
          showAlertAction: false,
          alertActionType: 0,
          alertActions: [],
          alertActionHideFromOutside: false,
          doAlertAction1() {
          },
          doAlertAction2() {
          },
          extra: {}

        },
        photos: {
          imgList: [],
          startViewIndex: 0,
          bigImgShow: false,
          from: '',
        },
        actUrlFromOutside: '',
        fromAd: false,
      }
    },
    components: {
      GreetDialog,
      MomentReportDialog,
      PhotoGallery,
      ReportBlockDialog,
      RequestCall,
      ScreenFull,
      CustomToast,
      MsgActionDialog,
      AlertDialog,
      rechargeSuc,
      DeviceError,
      RechargeDialog,
      HtmlPage,
      AutoPlayGuideDialog,
      PreLoader,
      LCMessageDialog,
      VcrGuide,
      BigVideoPlayer,
      VK,
      GameDialog,
      RoomToolDialog,
      CallEndDialog
    },
    mounted: function () {
      /* 调用全局Vue实例中的$EventBus事件总线中的$on属性,监听A组件发送
      到事件总线中的aMsg事件 */

      AppHelper.bindEvent(this)
      window.addEventListener('online', this.updateOnlineStatus);
      window.addEventListener('offline', this.updateOnlineStatus);
      IMManager.tryInitAVIMClient(this)
      let url = this.actUrlFromOutside
      if (url) {
        this.$EventBus.$emit(EventBusConstant.EVENT_SHOW_HC, 2, url)
        this.actUrlFromOutside = ''
      }

    },
    beforeDestroy() {
      AppHelper.unbindEvent(this)
      window.removeEventListener('online', this.updateOnlineStatus);
      window.removeEventListener('offline', this.updateOnlineStatus);
      HWLPLayer.clearAll()
      if (this.$root.$sseClient) {
        this.$root.$sseClient.disconnect()
      }
    },
    methods: {
      hideCallEndDialog() {
        this.callEnd.show = false
      },
      showVideo(src, poster) {
        if (isnull(src))
          return
        this.video.src = src
        this.video.poster = poster
        this.video.show = true
      },
      hideVideo() {
        this.video.show = false
      },
      toSayHI(accountId, doAfterSucceedCallback, doAfterFailedCallback) {
        MomentHelper.toSayHI(accountId, doAfterSucceedCallback, doAfterFailedCallback, this)
      },
      hideMomentReport(id, sucCallback) {
        this.momReport.show = false
      },
      removeLCMsg(item) {
        for (let i = 0; i < this.lcMsgList.length; i++) {
          let target = this.lcMsgList[i];
          if (item.uid == target.uid) {
            this.lcMsgList.splice(i, 1)
            return
          }
        }
      },
      hideHtmlDialogWidgetPage() {
        this.htmlPage.show = false
        if (this.htmlPage.type == 3 && !isnull(this.game.gameList)) {
          let _this = this
          setTimeout(() => {
            _this.game.show = true
          }, 200)
        }
      },
      reload() {
        this.isRouterAlive = false
        this.$nextTick(() => {
          this.isRouterAlive = true
        })
      },
      showDeviceErrorDialog() {
        this.showDeviceError = true
      },
      hideDeviceErrorDialog() {
        this.showDeviceError = false
      },
      updateOnlineStatus(e) {
        const {type} = e;
        let target = this
        this.onLine = type === 'online';
        this.$root.online = this.onLine
        // this.$emit(global.NET_CHANGE)
        if (!this.onLine) {
          this.showMsgAction(1, ['Ok'], [function (extra) {
            target.hideMsgActionDialog()
          }], {}, true, 'No network')
        } else {
          this.$EventBus.$emit(EventBusConstant.EVENT_NET_RECONNECT)
        }
      },
      showRechargeSucDialog(coin, svip = false) {
        this.rechargeSucCoin = coin
        this.rechargeType = global.isNormal() ? 1 : 2
        this.showAfRec = true
        this.svipAfRec = svip
      },
      hideRechargeSucDialog() {
        this.showAfRec = false
      },
      toSignup() {
        this.$EventBus.$emit(EventBusConstant.EVENT_TO_BIND_AFR)
      },
      hideMsgActionDialog() {
        this.msgAction.showMsgWithAction = false
      },
      showMsgAction(type, actions, callbacks = null, extra = {}, hideFromOut = true, msg = null) {
        this.msgAction.extra = extra
        this.msgAction.msgActionType = type
        this.msgAction.msgActions = actions
        this.msgAction.msgActionHideFromOutside = hideFromOut
        this.msgAction.showMsgWithAction = true
        if (!isnull(msg))
          this.msgAction.msg = msg
        if (!isnull(callbacks)) {
          if (callbacks.length > 0) {
            this.msgAction.doMsgAction1 = callbacks[0]
          }
          if (callbacks.length > 1) {
            this.msgAction.doMsgAction2 = callbacks[1]
          }
        }
      },
      leaveRTM() {
        if (!this.$root.rtm || !this.$root.rtm._logined) {
          return
        }
        let target = this;
        this.$root.rtm.logout().then(() => {
          console.log('logout')
          target.$root.rtm._logined = false
          Toast.notice('Logout: ' + pageObj.rtm.accountName)
          target.$root.$globalAppCfg.agoChatClient = null
        }).catch((err) => {
          console.log('Logout failed, please open console see more details')
          console.log(err)
        })
      },
      showAlertActionDialog(type, actions, callbacks = null, extra = {}, hideFromOut = true, title = null, msg = null) {
        this.alertAction.extra = extra
        this.alertAction.alertActionType = type
        this.alertAction.alertActions = actions
        this.alertAction.alertActionHideFromOutside = hideFromOut
        this.alertAction.showAlertAction = true
        if (!isnull(title)) {
          this.alertAction.title = title
        }
        if (!isnull(msg)) {
          this.alertAction.msg = msg
        }
        if (!isnull(callbacks)) {
          if (callbacks.length > 0) {
            this.alertAction.doAlertAction1 = callbacks[0]
          }
          if (callbacks.length > 1) {
            this.alertAction.doAlertAction2 = callbacks[1]
          }
        }
      },
      hideAlertActionDialog() {
        this.alertAction.showAlertAction = false
      },
      judgeAccount(successCallback = null, failCallback = null) {
        console.log(localGetBoolean(global.LOGIN_STATUS, false))
        if (!localGetBoolean(global.LOGIN_STATUS, false)) {
          if (global.isNormal()) {
            reloginInBg(function (data, page) {
              IMManager.tryInitAVIMClient(page)
              accountApi.fetchGlobalCfg((data, page) => {
                page.refreshGlobalCfg(data)
              }, null, page)
              router.togo('/')
              successCallback && successCallback(data, page)
            }, function (code, msg, page) {
              if (code == -10) {

                if (page.$sseClient) {
                  page.$sseClient.disconnect()
                }
                page.$globalAppCfg.sseSource = null
                page.$globalAppCfg.setUser({})
                page.$globalAppCfg.setSession('')
                page.$globalAppCfg.setGlobalParams({})
                localClear()
                router.togo('/')
                Toast.info(Tips.relogin_failed, page)
              }
              failCallback && failCallback(code, msg, page)
            }, this)
          } else
            validate(function (data, page) {
              IMManager.tryInitAVIMClient(page)
              accountApi.fetchGlobalCfg((data, page) => {
                page.refreshGlobalCfg(data)
              }, null, page)
              localSave(global.key.RELOAD_ROOM_LIST, true)
              router.togo('/')
              successCallback && successCallback(data, page)
            }, function (code, msg, page) {
              Toast.error(TipsUtils.getErrorTips(code), page)
              failCallback && failCallback(code, msg, page)
            })
          return false
        } else {
          IMManager.tryInitAVIMClient(this)
        }

      },
      refreshGlobalCfg(globalCfg) {
        global.saveCfg('bannerInfoList', globalCfg.bannerInfoList)
        global.saveCfg('voiceChatRoomBannerInfoList', globalCfg.voiceChatRoomBannerInfoList)
      },
      stopEvent(e) {
        e.preventDefault()
      },
      hideAllDialog() {
        this.photos.bigImgShow = false
        this.momReport.show = false
        this.greet.show = false
        this.report.show = false
        this.showRecharge = false
        this.showDeviceError = false
      },
      dealParams() {
        let params = this.$router.history?.pending?.query
        if (!isnull(params)) {
          params.install_time = getZoneTime(0, 'yyyy-MM-dd hh:mm:ss')
          localSave(global.key.FROM_LINK_PARAMS, JSON.stringify(params))
        }
        this.fromAd = !isnull(params?.media_source)
        this.$router.history.replace('/')
      },
    },
    watch: {
      $route() {   // 监听路由变化重新赋值
        if (this.$router.isleft) {
          this.transitionName = 'slideleft'
        }
        if (this.$router.isright) {
          this.transitionName = 'slideright'
        }
      },
      'photos.bigImgShow'(n, o) {
        if (n) {
          document.addEventListener('touchmove', this.stopEvent, {passive: false})
        } else {
          document.removeEventListener('touchmove', this.stopEvent, {passive: true})
        }
        document.body.style.overflowY = n ? 'hidden' : 'auto'
      },
      'greet.show'(n, o) {
        if (n) {
          BlackUtils.refreshList(this)
        }
      },
      'htmlPage.show'(n, o) {
        if (!n && this.htmlPage.type == 3) {
          accountApi.getAvailableCoins((data, page) => {
            global.setCoins(data)
            page.$EventBus.$emit(EventBusConstant.EVENT_COIN_CHANGE)
          }, () => {
          }, this)
        }
      }
    },
    created() {
      this.dealParams();
      StatisticsHelper.in_APP()
      global.setApplication(this)
      BlackUtils.fetchKeyWordsList()
      global.d()
      let target = this
      if (!isnull(localGet(global.key.session))) {
        createSSE(localGet(global.key.session), target)
        accountApi.fetchGlobalCfg((data, page) => {
          page.refreshGlobalCfg(data)
        }, null, target)
      }
      if (!localGetBoolean(global.LOGIN_STATUS, false)) {
        if (isnull(target.$globalAppCfg.deviceUUID)) {
          getUUID(target).then(() => {
            target.judgeAccount()
          })
        } else {
          target.judgeAccount()
        }
      }
      if (!isnull(global.getUserId(), global.user.accountId)) {
        this.root && this.$root.rtmManager && this.$root.rtmManager.logout()
        this.root && this.$root.rtmManager && this.$root.rtmManager.login()
      }

      router.beforeEach(async (to, from, next) => {
        hideDialog(this)
        global.setApplication(target)
        if (!isnull(localGet(global.key.session))) {
          createSSE(localGet(global.key.session), target)
        }
        if (!localGetBoolean(global.LOGIN_STATUS, false)) {
          if (isnull(target.$globalAppCfg.deviceUUID)) {
            getUUID(target).then(() => {
              target.judgeAccount()
            })
          } else {
            target.judgeAccount()
          }
        } else {
          IMManager.tryInitAVIMClient(target)
          next()
        }
        if (to.path == '/conv/chat') {
          this.$refs.newMsgLayer.removeAll()
        }
        target.hideAllDialog()

      })
      let url = decodeURI(location.href)
      if (!isnull(url)) {
        // this.fromAd = url.indexOf('?media_source=') != -1
        let startIndex = url.indexOf('?')
        if (startIndex < 0)
          return
        let paramStr = url.substr(startIndex + 1)
        let params = paramStr.split('&')
        let path = ''
        let actUrl = ''
        if (!isnull(params)) {
          for (let index = 0; index < params.length; index++) {
            let tmp = params[index]
            let kv = tmp.split('=')
            if (kv[0] == 'p') {
              path = kv[1]
              continue
            }
            if (kv[0] == 'act') {
              actUrl = kv[1]
              continue
            }
            actUrl += '&' + tmp
          }
          if (judgeLink(actUrl)) {
            this.actUrlFromOutside = formatLink(actUrl)
          }
          if (path) {
            router.togo('/' + path)
          }
        }
      }

    }
  }


</script>

<style lang="less">
  @import "~styles/variable.less";
  @import "~styles/index.less";


  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    height: 100%;
  }

  .Router {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    transition: all .5s ease;
    -webkit-transition: all .5s ease;
    -moz-transition: all .5s ease;
  }

  .slideleft-enter,
  .slideright-leave-active {
    opacity: 0;
    -webkit-transform: translate(100%, 0);
    transform: translate(100%, 0);
  }

  .slideleft-leave-active,
  .slideright-enter {
    opacity: 0;
    -webkit-transform: translate(-100%, 0);
    transform: translate(-100%, 0);
  }

  .vs-dialog__content.notFooter {
    padding: 0 !important;
    height: 100% !important;
  }

  .vs-dialog__close {
    border-radius: 17px !important;
    left: -6px !important;
  }

  .vs-notification-parent {
    text-align: center;
  }

  .vs-notification__content__text p {
    .fs(26);
  }

  .page.Router {
    background: #fff !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue